export default function AppSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.querySelector('#app');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500 to-primary-700 rounded-3xl p-8 md:p-12 lg:p-16 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/3 -translate-x-1/4"></div>

          <div className="flex-1 relative z-10 flex flex-col gap-4">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/20 text-white text-xs font-medium w-fit">
              <i className="ri-smartphone-line text-sm"></i>
              移动客户端
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-white">随时随地，畅快吃瓜</h2>
            <p className="text-sm md:text-base text-white/80 leading-relaxed max-w-[480px]">
              下载吃瓜网51移动客户端，随时随地浏览最新八卦爆料，参与热门话题讨论。支持iOS和Android双平台，推送提醒不错过任何一个大瓜。
            </p>
            <div className="flex flex-wrap gap-3 mt-2">
              <a
                href="#app"
                onClick={handleClick}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white text-primary-600 font-medium text-sm hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 版下载
              </a>
              <a
                href="#app"
                onClick={handleClick}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white/15 text-white font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer border border-white/20"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 版下载
              </a>
            </div>
            <div className="flex items-center gap-4 mt-1">
              <div className="flex items-center gap-1.5">
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <span className="text-white/80 text-xs">4.8分</span>
              </div>
              <span className="text-white/30 text-xs">|</span>
              <span className="text-white/80 text-xs">500万+ 下载</span>
              <span className="text-white/30 text-xs">|</span>
              <span className="text-white/80 text-xs">安全无毒</span>
            </div>
          </div>

          <div className="relative z-10 w-full max-w-[280px] md:max-w-[320px]">
            <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden bg-white/10 border border-white/20">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20mobile%20app%20mockup%20showing%20a%20Chinese%20social%20discussion%20forum%20interface%20with%20warm%20coral%20accent%20colors%2C%20trending%20topics%20list%2C%20modern%20UI%20design%2C%20soft%20shadows%2C%20minimal%20layout%2C%20editorial%20quality%2C%20professional%20app%20screenshot%20style&width=640&height=854&seq=app-mockup-01&orientation=portrait"
                alt="吃瓜网51移动客户端界面预览 - 随时随地浏览八卦爆料"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}